import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { StockInventorySummaryDto } from './type/StockInventorySummaryDto';

const ENDPOINT = `${APIConfiguration.sparePart}stockInventory/Update/${COMMON_QUERY_PARAMS.STOCK_ITEM_ID}`;

export interface UpdateInventoryCommandArgs {
  stockInventoryId: string;
  stockInventoryName?: string;
  supervisorUserId?: string;
  inventoryClerkUserId?: string;
}

export default async function updateInventoryCommand({
  stockInventoryId,
  stockInventoryName,
  supervisorUserId,
  inventoryClerkUserId,
}: UpdateInventoryCommandArgs): Promise<
  BackResponse<StockInventorySummaryDto> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<StockInventorySummaryDto>>(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.STOCK_ITEM_ID, stockInventoryId),
      {
        method: SUPPORTED_METHODS.PUT,
        json: {
          stockInventoryName,
          supervisorUserId,
          inventoryClerkUserId,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
